/*
 * @Author: liujunhong
 * @Date: 2023/7/5
 * @Desc: nav
 */

import React, { ReactNode } from 'react';
import { Menu } from 'antd';
import './style.less';
import { NavLink } from 'react-router-dom';

export const KF_URL = {
  stolenAndRecovered: '//we.gyyx.cn/kf/kfItemsRecovered',
  transactionAppeal: '//we.gyyx.cn/kf/QiBaoItemsRecovered',
  gameUnblock: '//we.gyyx.cn/kf/kfItemsResume',
  serviceTracker: '//we.gyyx.cn/kf/kfTrackIndex',
  index: '//we.gyyx.cn/kf/index',
};

interface IMenuItem {
  label: string | ReactNode;
  key: string;
  url?: string;
  children?: Array<IMenuItem>;
  id?: string;
}

interface IProps {
  //默认高亮的菜单: 首页 home | 账号管理 accountManagement |我要充值 | 客服中心 kfCenter
  activeMenu?: 'home' | 'accountManagement' | 'pay' | 'kfCenter';
}

const navMenu: Array<IMenuItem> = [
  {
    label: '首页',
    key: 'home',
    url: '/',
    id: 'we_nav_home',
  },
  {
    label: '我要充值',
    key: 'pay',
    url: '/wegame_pay',
    id: 'we_nav_pay',
  },
  {
    label: '账号中心',
    url: '/original_phone',
    key: 'accountManagement',
    id: 'gy_account_manage',
    children: [
      {
        label: '更换绑定APP',
        key: 'original_phone',
        url: '/original_phone',
        id: 'original_phone',
      },
      {
        label: '游戏自助封停',
        key: 'closure_info',
        url: '/closure_info',
        id: 'closure_info',
      },
      {
        label: '游戏自助解封',
        key: 'unlock_info',
        url: '/unlock_info',
        id: 'unlock_info',
      },
    ],
  },
  {
    label: '客服中心',
    url: '/kf',
    key: 'kfCenter',
    id: 'kf',
    children: [
      {
        label: '游戏物品被盗找回',
        key: 'kf/kfItemsRecovered',
        url: '/kf/kfItemsRecovered',
        id: 'kf/kfItemsRecovered',
      },
      {
        label: '奇宝斋物品交易申诉',
        key: 'kf/QiBaoItemsRecovered',
        url: '/kf/QiBaoItemsRecovered',
        id: 'kf/QiBaoItemsRecovered',
      },
      {
        label: '游戏解封申请',
        key: 'kf/kfItemsResume',
        url: '/kf/kfItemsResume',
        id: 'kf/kfItemsResume',
      },
      {
        label: '服务跟踪',
        key: 'kf/kfTrackIndex',
        url: '/kf/kfTrackIndex',
        id: 'kf/kfTrackIndex',
      },
    ],
  },
];


const AccountNav = (props: IProps) => {
  const {activeMenu = 'home'} = props;


  const renderMenu = (menuList: Array<IMenuItem>) => {
    return menuList.map(item => {
      if (item.children) {
        return <Menu.SubMenu
          popupClassName="custom_sub_menu"
          key={item.key}
          title={item.url ? <NavLink to={item.url} id={item.id}>{item.label}</NavLink> : item.label}
        >
          {renderMenu(item.children)}
        </Menu.SubMenu>;
      } else {
        return <Menu.Item key={item.key}>
          {item.url ? <NavLink to={item.url} id={item.id}>{item.label}</NavLink> : item.label}
        </Menu.Item>;
      }
    });
  };

  return (
    <div className="account_nav">
      <div className="nav_wrap">
        {/*<div className="logo_pay">*/}
        {/*  <img src="//img.gyyxcdn.cn/account/Content/images/logo_account.gif" alt=""/>*/}
        {/*</div>*/}
        <div className="nav_menu">
          <Menu mode="horizontal" defaultSelectedKeys={[activeMenu]}>
            {renderMenu(navMenu)}
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default AccountNav;
